import { z } from 'zod';

export const itemIdsTreeSchema = z
  .object({
    ids: z.array(z.number().int().positive()),
    parentIds: z.array(z.number().int().positive().nullable()),
  })
  .superRefine((value, ctx) => {
    if (value.ids.length !== value.parentIds.length) {
      ctx.addIssue({
        code: 'custom',
        message: 'ids and parentIds must have the same length',
        path: ['parentIds'],
      });
    }
  });

export type ItemIdsTreeDTO = z.infer<typeof itemIdsTreeSchema>;
